module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.678 6A2 2 0 017.61 7.482L8.016 9h18.746a.5.5 0 01.483.63l-2.382 8.888A2 2 0 0122.931 20H10.964l.3 1.119c.498.16.928.471 1.235.88h9.002A2.5 2.5 0 1121.05 24h-8.1a2.5 2.5 0 11-3.7-2.666L5.777 8.371A.5.5 0 005.294 8H4.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm19.129 5H8.552l1.876 7h12.12a.5.5 0 00.482-.37z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/system/asda-trolley.svg
// module id = 708
// module chunks = 0